import React from "react";
import { Box, MainText } from "app/components/common";

interface Props {
  text: string;
}

const SkillLabel = ({ text }: Props) => {
  return (
    <Box
      backgroundColor="brand.500"
      paddingHorizontal="xs"
      alignItems="center"
      justifyContent="center"
      paddingVertical={2}
      borderRadius={200}
    >
      <MainText variant="l2-bold" color="neutral.white">
        {text}
      </MainText>
    </Box>
  );
};

export { SkillLabel };
